/**
 * Judge Search Hook
 * Hook for Judge search functionality
 */

import { type JudgeSearchResponse } from '../../types';

import { useCourtSearch } from './useBaseCourtApi';

/**
 * Hook for Judge search functionality
 */
export const useJudgeSearch = (
  initialQuery: string = '',
  exactMatch: boolean = true
) => {
  const searchHook = useCourtSearch<JudgeSearchResponse>({
    searchType: 'p',
    queryKeyPrefix: 'judge-search-v2',
    initialQuery,
    exactMatch,
  });

  return {
    judgeSearchResults: searchHook.results,
    searchQuery: searchHook.searchQuery,
    sortOption: searchHook.sortOption,

    isSearching: searchHook.isSearching,
    isAnyLoading: searchHook.isAnyLoading,
    hasResults: searchHook.hasResults,
    hasError: searchHook.hasError,
    generalError: searchHook.generalError,
    isTokenLoading: searchHook.isTokenLoading,
    isPaginationLoading: searchHook.isPaginationLoading,

    triggerCombinedSearch: searchHook.triggerCombinedSearch,
    setSortOption: searchHook.setSortOption,
    updateJudgeSearchResults: searchHook.updateResults,
    setPaginationLoading: searchHook.setPaginationLoading,
    setSearchExecuted: searchHook.setSearchExecuted,

    error: searchHook.error,
    data: searchHook.data,
    refetch: searchHook.refetch,
  };
};
